/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BodyPopulateQueueApiTasksPopulateQueuePost,
  BodyScheduleGroupTasksApiTasksScheduleGroupPost,
  BotTaskMessage,
  ClearPendingTasksResponse,
  HTTPValidationError,
  InputTask,
  InputTaskExecution,
  QueueTask,
  RunTaskResponse,
  ScheduleGroupTasksResponse,
  ScheduledTaskResponse,
  SleepScheduleRequest,
  SleepScheduleResponse,
  TaskExecutionResponse,
  TaskResponse,
  UpdateTaskExecutionRequest,
  UpdateTaskExecutionResponse,
} from '../models/index';
import {
    BodyPopulateQueueApiTasksPopulateQueuePostFromJSON,
    BodyPopulateQueueApiTasksPopulateQueuePostToJSON,
    BodyScheduleGroupTasksApiTasksScheduleGroupPostFromJSON,
    BodyScheduleGroupTasksApiTasksScheduleGroupPostToJSON,
    BotTaskMessageFromJSON,
    BotTaskMessageToJSON,
    ClearPendingTasksResponseFromJSON,
    ClearPendingTasksResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    InputTaskFromJSON,
    InputTaskToJSON,
    InputTaskExecutionFromJSON,
    InputTaskExecutionToJSON,
    QueueTaskFromJSON,
    QueueTaskToJSON,
    RunTaskResponseFromJSON,
    RunTaskResponseToJSON,
    ScheduleGroupTasksResponseFromJSON,
    ScheduleGroupTasksResponseToJSON,
    ScheduledTaskResponseFromJSON,
    ScheduledTaskResponseToJSON,
    SleepScheduleRequestFromJSON,
    SleepScheduleRequestToJSON,
    SleepScheduleResponseFromJSON,
    SleepScheduleResponseToJSON,
    TaskExecutionResponseFromJSON,
    TaskExecutionResponseToJSON,
    TaskResponseFromJSON,
    TaskResponseToJSON,
    UpdateTaskExecutionRequestFromJSON,
    UpdateTaskExecutionRequestToJSON,
    UpdateTaskExecutionResponseFromJSON,
    UpdateTaskExecutionResponseToJSON,
} from '../models/index';

export interface AssignTaskApiTasksAssignPostRequest {
    inputTaskExecution: InputTaskExecution;
    xApiKey?: string | null;
}

export interface ClearPendingApiTasksExecutionsPendingDeleteRequest {
    groupId?: number | null;
    xApiKey?: string | null;
}

export interface CreateTaskApiTasksPostRequest {
    inputTask: InputTask;
    xApiKey?: string | null;
}

export interface GenerateSleepBlocksApiTasksGenerateSleepBlocksPostRequest {
    sleepScheduleRequest: SleepScheduleRequest;
    xApiKey?: string | null;
}

export interface GetExecutionsApiTasksExecutionsGetRequest {
    timeBackSeconds?: number;
    startTime?: Date | null;
    endTime?: Date | null;
    xApiKey?: string | null;
    requestBody?: Array<string> | null;
}

export interface GetNextTaskApiTasksExecutionsNextUserIdGetRequest {
    userId: string;
    xApiKey?: string | null;
}

export interface GetQueueMessageSchemaApiTasksQueueMessageSchemaGetRequest {
    xApiKey?: string | null;
}

export interface GetQueuedTaskSchemaApiTasksQueuedTaskSchemaGetRequest {
    xApiKey?: string | null;
}

export interface GetScheduleApiTasksScheduleGetRequest {
    userIds?: string | null;
    timeBackSeconds?: number;
    xApiKey?: string | null;
}

export interface GetTasksApiTasksGetRequest {
    xApiKey?: string | null;
}

export interface PopulateQueueApiTasksPopulateQueuePostRequest {
    bodyPopulateQueueApiTasksPopulateQueuePost: BodyPopulateQueueApiTasksPopulateQueuePost;
    xApiKey?: string | null;
}

export interface ScheduleGroupTasksApiTasksScheduleGroupPostRequest {
    bodyScheduleGroupTasksApiTasksScheduleGroupPost: BodyScheduleGroupTasksApiTasksScheduleGroupPost;
    xApiKey?: string | null;
}

export interface UpdateExecutionApiTasksExecutionsTaskExecutionIdPatchRequest {
    taskExecutionId: number;
    updateTaskExecutionRequest: UpdateTaskExecutionRequest;
    xApiKey?: string | null;
}

export interface UpdateStatusApiTasksExecutionsStatusPostRequest {
    updateTaskExecutionRequest: UpdateTaskExecutionRequest;
    xApiKey?: string | null;
}

/**
 * 
 */
export class TasksApi extends runtime.BaseAPI {

    /**
     * Assign Task
     */
    async assignTaskApiTasksAssignPostRaw(requestParameters: AssignTaskApiTasksAssignPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskExecutionResponse>> {
        if (requestParameters['inputTaskExecution'] == null) {
            throw new runtime.RequiredError(
                'inputTaskExecution',
                'Required parameter "inputTaskExecution" was null or undefined when calling assignTaskApiTasksAssignPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/tasks/assign`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputTaskExecutionToJSON(requestParameters['inputTaskExecution']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskExecutionResponseFromJSON(jsonValue));
    }

    /**
     * Assign Task
     */
    async assignTaskApiTasksAssignPost(requestParameters: AssignTaskApiTasksAssignPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskExecutionResponse> {
        const response = await this.assignTaskApiTasksAssignPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Clear Pending
     */
    async clearPendingApiTasksExecutionsPendingDeleteRaw(requestParameters: ClearPendingApiTasksExecutionsPendingDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClearPendingTasksResponse>> {
        const queryParameters: any = {};

        if (requestParameters['groupId'] != null) {
            queryParameters['group_id'] = requestParameters['groupId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/tasks/executions/pending`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClearPendingTasksResponseFromJSON(jsonValue));
    }

    /**
     * Clear Pending
     */
    async clearPendingApiTasksExecutionsPendingDelete(requestParameters: ClearPendingApiTasksExecutionsPendingDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClearPendingTasksResponse> {
        const response = await this.clearPendingApiTasksExecutionsPendingDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Task
     */
    async createTaskApiTasksPostRaw(requestParameters: CreateTaskApiTasksPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskResponse>> {
        if (requestParameters['inputTask'] == null) {
            throw new runtime.RequiredError(
                'inputTask',
                'Required parameter "inputTask" was null or undefined when calling createTaskApiTasksPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/tasks`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputTaskToJSON(requestParameters['inputTask']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskResponseFromJSON(jsonValue));
    }

    /**
     * Create Task
     */
    async createTaskApiTasksPost(requestParameters: CreateTaskApiTasksPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskResponse> {
        const response = await this.createTaskApiTasksPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Sleep Blocks
     */
    async generateSleepBlocksApiTasksGenerateSleepBlocksPostRaw(requestParameters: GenerateSleepBlocksApiTasksGenerateSleepBlocksPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SleepScheduleResponse>> {
        if (requestParameters['sleepScheduleRequest'] == null) {
            throw new runtime.RequiredError(
                'sleepScheduleRequest',
                'Required parameter "sleepScheduleRequest" was null or undefined when calling generateSleepBlocksApiTasksGenerateSleepBlocksPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/tasks/generate_sleep_blocks`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SleepScheduleRequestToJSON(requestParameters['sleepScheduleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SleepScheduleResponseFromJSON(jsonValue));
    }

    /**
     * Generate Sleep Blocks
     */
    async generateSleepBlocksApiTasksGenerateSleepBlocksPost(requestParameters: GenerateSleepBlocksApiTasksGenerateSleepBlocksPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SleepScheduleResponse> {
        const response = await this.generateSleepBlocksApiTasksGenerateSleepBlocksPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Executions
     */
    async getExecutionsApiTasksExecutionsGetRaw(requestParameters: GetExecutionsApiTasksExecutionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TaskExecutionResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['timeBackSeconds'] != null) {
            queryParameters['time_back_seconds'] = requestParameters['timeBackSeconds'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['start_time'] = (requestParameters['startTime'] as any).toISOString();
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['end_time'] = (requestParameters['endTime'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/tasks/executions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TaskExecutionResponseFromJSON));
    }

    /**
     * Get Executions
     */
    async getExecutionsApiTasksExecutionsGet(requestParameters: GetExecutionsApiTasksExecutionsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TaskExecutionResponse>> {
        const response = await this.getExecutionsApiTasksExecutionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Next Task
     */
    async getNextTaskApiTasksExecutionsNextUserIdGetRaw(requestParameters: GetNextTaskApiTasksExecutionsNextUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RunTaskResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getNextTaskApiTasksExecutionsNextUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/tasks/executions/next/{user_id}`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RunTaskResponseFromJSON(jsonValue));
    }

    /**
     * Get Next Task
     */
    async getNextTaskApiTasksExecutionsNextUserIdGet(requestParameters: GetNextTaskApiTasksExecutionsNextUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RunTaskResponse> {
        const response = await this.getNextTaskApiTasksExecutionsNextUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Dummy endpoint to expose BotTaskMessage in the OpenAPI spec for client generation.
     * Get Queue Message Schema
     */
    async getQueueMessageSchemaApiTasksQueueMessageSchemaGetRaw(requestParameters: GetQueueMessageSchemaApiTasksQueueMessageSchemaGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BotTaskMessage>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/tasks/queue_message_schema`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BotTaskMessageFromJSON(jsonValue));
    }

    /**
     * Dummy endpoint to expose BotTaskMessage in the OpenAPI spec for client generation.
     * Get Queue Message Schema
     */
    async getQueueMessageSchemaApiTasksQueueMessageSchemaGet(requestParameters: GetQueueMessageSchemaApiTasksQueueMessageSchemaGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BotTaskMessage> {
        const response = await this.getQueueMessageSchemaApiTasksQueueMessageSchemaGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Dummy endpoint to expose QueueTask in the OpenAPI spec for client generation.
     * Get Queued Task Schema
     */
    async getQueuedTaskSchemaApiTasksQueuedTaskSchemaGetRaw(requestParameters: GetQueuedTaskSchemaApiTasksQueuedTaskSchemaGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QueueTask>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/tasks/queued_task_schema`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QueueTaskFromJSON(jsonValue));
    }

    /**
     * Dummy endpoint to expose QueueTask in the OpenAPI spec for client generation.
     * Get Queued Task Schema
     */
    async getQueuedTaskSchemaApiTasksQueuedTaskSchemaGet(requestParameters: GetQueuedTaskSchemaApiTasksQueuedTaskSchemaGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QueueTask> {
        const response = await this.getQueuedTaskSchemaApiTasksQueuedTaskSchemaGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Schedule
     */
    async getScheduleApiTasksScheduleGetRaw(requestParameters: GetScheduleApiTasksScheduleGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ScheduledTaskResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['userIds'] != null) {
            queryParameters['user_ids'] = requestParameters['userIds'];
        }

        if (requestParameters['timeBackSeconds'] != null) {
            queryParameters['time_back_seconds'] = requestParameters['timeBackSeconds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/tasks/schedule`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ScheduledTaskResponseFromJSON));
    }

    /**
     * Get Schedule
     */
    async getScheduleApiTasksScheduleGet(requestParameters: GetScheduleApiTasksScheduleGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ScheduledTaskResponse>> {
        const response = await this.getScheduleApiTasksScheduleGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Tasks
     */
    async getTasksApiTasksGetRaw(requestParameters: GetTasksApiTasksGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TaskResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/tasks`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TaskResponseFromJSON));
    }

    /**
     * Get Tasks
     */
    async getTasksApiTasksGet(requestParameters: GetTasksApiTasksGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TaskResponse>> {
        const response = await this.getTasksApiTasksGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Populate the queue with tasks for a group.
     * Populate Queue
     */
    async populateQueueApiTasksPopulateQueuePostRaw(requestParameters: PopulateQueueApiTasksPopulateQueuePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScheduleGroupTasksResponse>> {
        if (requestParameters['bodyPopulateQueueApiTasksPopulateQueuePost'] == null) {
            throw new runtime.RequiredError(
                'bodyPopulateQueueApiTasksPopulateQueuePost',
                'Required parameter "bodyPopulateQueueApiTasksPopulateQueuePost" was null or undefined when calling populateQueueApiTasksPopulateQueuePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/tasks/populate_queue`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BodyPopulateQueueApiTasksPopulateQueuePostToJSON(requestParameters['bodyPopulateQueueApiTasksPopulateQueuePost']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScheduleGroupTasksResponseFromJSON(jsonValue));
    }

    /**
     * Populate the queue with tasks for a group.
     * Populate Queue
     */
    async populateQueueApiTasksPopulateQueuePost(requestParameters: PopulateQueueApiTasksPopulateQueuePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScheduleGroupTasksResponse> {
        const response = await this.populateQueueApiTasksPopulateQueuePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Schedule Group Tasks
     */
    async scheduleGroupTasksApiTasksScheduleGroupPostRaw(requestParameters: ScheduleGroupTasksApiTasksScheduleGroupPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScheduleGroupTasksResponse>> {
        if (requestParameters['bodyScheduleGroupTasksApiTasksScheduleGroupPost'] == null) {
            throw new runtime.RequiredError(
                'bodyScheduleGroupTasksApiTasksScheduleGroupPost',
                'Required parameter "bodyScheduleGroupTasksApiTasksScheduleGroupPost" was null or undefined when calling scheduleGroupTasksApiTasksScheduleGroupPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/tasks/schedule_group`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BodyScheduleGroupTasksApiTasksScheduleGroupPostToJSON(requestParameters['bodyScheduleGroupTasksApiTasksScheduleGroupPost']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScheduleGroupTasksResponseFromJSON(jsonValue));
    }

    /**
     * Schedule Group Tasks
     */
    async scheduleGroupTasksApiTasksScheduleGroupPost(requestParameters: ScheduleGroupTasksApiTasksScheduleGroupPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScheduleGroupTasksResponse> {
        const response = await this.scheduleGroupTasksApiTasksScheduleGroupPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Execution
     */
    async updateExecutionApiTasksExecutionsTaskExecutionIdPatchRaw(requestParameters: UpdateExecutionApiTasksExecutionsTaskExecutionIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateTaskExecutionResponse>> {
        if (requestParameters['taskExecutionId'] == null) {
            throw new runtime.RequiredError(
                'taskExecutionId',
                'Required parameter "taskExecutionId" was null or undefined when calling updateExecutionApiTasksExecutionsTaskExecutionIdPatch().'
            );
        }

        if (requestParameters['updateTaskExecutionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTaskExecutionRequest',
                'Required parameter "updateTaskExecutionRequest" was null or undefined when calling updateExecutionApiTasksExecutionsTaskExecutionIdPatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/tasks/executions/{task_execution_id}`;
        urlPath = urlPath.replace(`{${"task_execution_id"}}`, encodeURIComponent(String(requestParameters['taskExecutionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTaskExecutionRequestToJSON(requestParameters['updateTaskExecutionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateTaskExecutionResponseFromJSON(jsonValue));
    }

    /**
     * Update Execution
     */
    async updateExecutionApiTasksExecutionsTaskExecutionIdPatch(requestParameters: UpdateExecutionApiTasksExecutionsTaskExecutionIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateTaskExecutionResponse> {
        const response = await this.updateExecutionApiTasksExecutionsTaskExecutionIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Status
     */
    async updateStatusApiTasksExecutionsStatusPostRaw(requestParameters: UpdateStatusApiTasksExecutionsStatusPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['updateTaskExecutionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTaskExecutionRequest',
                'Required parameter "updateTaskExecutionRequest" was null or undefined when calling updateStatusApiTasksExecutionsStatusPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/tasks/executions/status`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTaskExecutionRequestToJSON(requestParameters['updateTaskExecutionRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Update Status
     */
    async updateStatusApiTasksExecutionsStatusPost(requestParameters: UpdateStatusApiTasksExecutionsStatusPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateStatusApiTasksExecutionsStatusPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
